import { defineAsyncComponent } from 'vue';

const Dashboard = defineAsyncComponent(
  () => import('@/views/Dashboard/Dashboard.vue')
);

export default Dashboard;
